import { AppDialogResult } from '@service/dialog/app-dialog';
import { AppDialogRef } from '@service/dialog/app-dialog-reference';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { first, Observable } from 'rxjs';

/**
 * Implenentación de la referencia del dialogo de PrimeNG
 */
export class PrimeDialogRef implements AppDialogRef {
  private ref?: DynamicDialogRef;

  constructor(ref: DynamicDialogRef) {
    this.ref = ref;
  }

  /**
   * Cierra el dialogo y opcionalmente devuelve un resultado
   * @param result Resultado del dialogo
   */
  close(result?: AppDialogResult): void {
    this.ref?.close(result);
  }

  /**
   * Devuelve el resultado del dialogo
   * @returns Observable<AppDialogResult>
   */
  getResult(): Observable<AppDialogResult> {
    return this.ref?.onClose.pipe(first()) as Observable<AppDialogResult>;
  }

  /**
   * Crea una nueva instancia de la referencia del dialogo
   * @param ref Referencia del dialogo
   * @returns PrimeDialogRef
   */
  static newInstance(ref: DynamicDialogRef): PrimeDialogRef {
    return new PrimeDialogRef(ref);
  }
}
